import React from 'react';
import {
	Typography,
	Box,
	Collapse,
} from '@material-ui/core';
import {
	KeyboardArrowUp as KeyboardArrowUpIcon,
	KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@material-ui/icons';
import {
	AccordionContainer,
	AccordionHeader,
	AccordionTitle,
	AccordionContent,
} from './ProductFilter.style';

const AccordionItem = ({title, isOpen, onToggle, children, classes}) => (
	<AccordionContainer className={classes.accordionItem}>
		<AccordionHeader onClick={onToggle}>
			<AccordionTitle>
				<Typography variant="subtitle1">{title}</Typography>
			</AccordionTitle>
			<Box className={`${classes.accordionIcon} ${isOpen ? classes.accordionIconRotate : ''}`}>
				{isOpen ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
			</Box>
		</AccordionHeader>
		<Collapse in={isOpen} timeout={400}>
			<AccordionContent>
				<Box mt={1}>{children}</Box>
			</AccordionContent>
		</Collapse>
	</AccordionContainer>
);

export default React.memo(AccordionItem);